import {listCustomerOfferBindingDefinitions} from "@project/sdk/sales";
import {ListCustomerOfferBindingDefinitionsResponse} from "@project/sdk/sales/zod";
import {queryOptions} from "@tanstack/react-query";
import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {customerOfferKeys} from "../../../customerOffer-keys";
import {assertCustomerOfferBindingDefinitions} from "../../../customerOffer-read";

export function listCustomerOfferBindingDefinitionsQueryOptions() {
  return queryOptions({
    ...queryPolicyDefaults.warm,
    queryKey: customerOfferKeys.bindingDefinitions(),
    queryFn: async ({signal}) => {
      const response = await listCustomerOfferBindingDefinitions({signal});
      const parsed = ListCustomerOfferBindingDefinitionsResponse.parse(response);
      assertCustomerOfferBindingDefinitions(parsed, response);
      return parsed;
    },
  });
}
